const tenantroles = {
	title: "Tenant Roles",
	new_tenantrole: "New Tenant Role",
	edit_tenantrole: "Edit Tenant Role: {name}",
	view_tenantrole: "View Tenant Role: {name}",
	list_title: "List of Tenant Roles",
	list_subtitle: "Manage Tenant Roles",
	create_title: "Create New Tenant Role",
	update_title: "Update Tenant Role",
	id: "ID",
	name: "Name",
	slug: "Slug",
};
export default tenantroles;